/** Espelha public.tipo_item_nfe_entrada em db_repo_dfe. */
export enum TipoItemNFeEntradaEnum {
  Produto = 1,
  Servico = 2,
}
